import { render, staticRenderFns } from "./PanelWindow.vue?vue&type=template&id=7bc13713&scoped=true&"
import script from "./PanelWindow.vue?vue&type=script&lang=js&"
export * from "./PanelWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc13713",
  null
  
)

export default component.exports